export const phoneSettings = {
    formatter: (value) => {
        let tel = value.replace(/\D/g,'');

        if(tel.length > 3 && tel.length <= 6){
            tel = tel.substr(0, 3) + "-" + tel.substr(3)
        } else if(tel.length >= 7){
            debugger;
            tel = tel.substr(0, 3) + "-" + tel.substr(3, 3) + "-" + tel.substr(6)
        }
        return tel;
    },
    maxlength: 12
}

export const defaultSettings = {
    formatter: (value) => {
        return value;
    }
}